/* Verkleinert das Kundenfoto im Browser, bevor TeeInBlue es hochlaedt.
   Nur fuer Produkte mit dem Tag "tib-foto-galerie" - dort erzeugt Gemini das
   Kunstwerk und das Foto ist reine Referenz. Bei allen anderen Produkten wird
   das Original gedruckt, dort laedt dieses Skript gar nicht erst.

   Warum ueberhaupt: TeeInBlue skaliert bei Bildfilter-Feldern zwar selbst
   (app-v1.js, xu(datei, 2000)), aber mit toDataURL(typ, 1) - also Qualitaet
   100 % und Base64. Ein 2000er JPEG in voller Qualitaet liegt bei 4-7 MB. Ab
   5 MB Dateigroesse laedt die App zusaetzlich eine zweite, kleine Fassung hoch
   (PRESIGNED_LARGE_MIN_FILESIZE), der Upload passiert also doppelt. Wer das
   Bild vorher auf 1536 px / ~0,8 MB bringt, spart beide Kosten: die grosse
   Uebertragung und das doppelte Hochladen. Fuer die Bilderkennung reicht das -
   Gemini rechnet Bildkacheln ohnehin auf 768 px herunter.

   Ablauf: Wir hoeren das "change" des Datei-Feldes in der Einfangphase am
   Dokument ab, halten es an, ersetzen input.files durch die verkleinerte Datei
   und feuern "change" erneut. Ab da laeuft der normale Weg der App weiter -
   Zuschneide-Dialog, Upload, KI. Geht irgendetwas schief (HEIC ohne
   Browser-Unterstuetzung, Speichermangel, Zeitueberschreitung), wird das
   Original unveraendert durchgereicht. */
(function () {
  'use strict';

  var schalter = document.querySelector('script[data-paws-kompress]');
  if (!schalter || schalter.getAttribute('data-paws-kompress') !== '1') return;

  /* 1536 px lange Kante: Gemini zerlegt Bilder in 768-px-Kacheln, mehr als
     zwei Kacheln je Seite bringen fuer Fellmuster und Augenfarbe nichts mehr.
     Gleichzeitig bleibt genug Reserve, damit der Zuschneide-Dialog der App
     einen Ausschnitt nehmen kann, ohne dass es matschig wird. */
  var ZIEL_KANTE = 1536;
  var QUALITAET = 0.82;
  /* Zweiter Anlauf mit weniger Qualitaet, falls die Datei ueber dem Ziel
     bleibt (kommt bei sehr detailreichen Bildern vor). */
  var QUALITAET_NOTFALL = 0.7;
  var ZIEL_BYTES = 1024 * 1024;
  /* Unterhalb dieser Groesse lohnt der Aufwand nicht - das Umrechnen kostet
     auf schwachen Geraeten mehr Zeit, als der kleinere Upload spart. */
  var LOHNT_AB_BYTES = 700 * 1024;
  /* Reissleine: dauert das Verkleinern laenger, geht das Original raus.
     Ein haengender Upload ist schlimmer als ein grosser. */
  var GRENZE_MS = 8000;

  var erledigt = new WeakSet();
  var laeuft = new WeakSet();

  function melden(name, nutzlast) {
    try {
      if (window.pawsInsights && window.pawsInsights.track) {
        window.pawsInsights.track(name, nutzlast || {});
      }
    } catch (e) {
      /* Tracking darf den Upload niemals stoppen. */
    }
  }

  /* Der Name landet spaeter in einer File und geht an die API der App.
     Pfadanteile und Steuerzeichen haben dort nichts zu suchen. */
  function nameSaeubern(roh) {
    var basis = String(roh || 'foto').split(/[\\/]/).pop();
    basis = basis.replace(/\.[^.]+$/, '').replace(/[^\w.\- ]+/g, '').trim();
    if (!basis) basis = 'foto';
    return basis.slice(0, 60) + '.jpg';
  }

  function mitZeitgrenze(versprechen, ms) {
    return new Promise(function (aufloesen, ablehnen) {
      var uhr = window.setTimeout(function () {
        ablehnen(new Error('zeitgrenze'));
      }, ms);
      versprechen.then(
        function (wert) {
          window.clearTimeout(uhr);
          aufloesen(wert);
        },
        function (fehler) {
          window.clearTimeout(uhr);
          ablehnen(fehler);
        }
      );
    });
  }

  /* Ein <img> wendet die EXIF-Drehung seit Chrome 81, Safari 13.1 und
     Firefox 77 von sich aus an. Das ist der verlaessliche Weg. */
  function ueberBildElement(datei) {
    return new Promise(function (aufloesen, ablehnen) {
      var url = URL.createObjectURL(datei);
      var bild = new Image();
      bild.onload = function () {
        URL.revokeObjectURL(url);
        aufloesen(bild);
      };
      bild.onerror = function () {
        URL.revokeObjectURL(url);
        ablehnen(new Error('nicht_lesbar'));
      };
      bild.src = url;
    });
  }

  var orientierungFehlt = false;

  /* imageOrientation: 'from-image' ist der entscheidende Teil. Ohne ihn landen
     Hochkantfotos vom Handy liegend auf der Leinwand, weil die Drehung nur in
     den EXIF-Daten steht und beim Zeichnen auf ein Canvas verloren geht.

     Safari kennt die Einstellung erst ab Version 17. Aeltere Fassungen werfen
     dabei keinen Fehler, sondern ueberlesen sie stillschweigend - das Bild
     kaeme also gedreht heraus, ohne dass es jemand merkt. Der Getter unten
     verraet, ob der Browser die Einstellung ueberhaupt gelesen hat: Nach der
     WebIDL-Regel fragt er nur Felder ab, die er kennt. Bleibt er stumm, gehen
     wir ueber das <img>-Element. */
  function bildLesen(datei) {
    if (typeof window.createImageBitmap === 'function' && !orientierungFehlt) {
      try {
        var gelesen = false;
        var einstellung = {};
        Object.defineProperty(einstellung, 'imageOrientation', {
          get: function () {
            gelesen = true;
            return 'from-image';
          }
        });
        return window.createImageBitmap(datei, einstellung).then(
          function (bild) {
            if (gelesen) return bild;
            orientierungFehlt = true;
            if (typeof bild.close === 'function') bild.close();
            return ueberBildElement(datei);
          },
          function () {
            return ueberBildElement(datei);
          }
        );
      } catch (e) {
        /* Manche Fassungen werfen schon beim Aufruf. */
      }
    }
    return ueberBildElement(datei);
  }

  function leinwand(breite, hoehe) {
    var c = document.createElement('canvas');
    c.width = breite;
    c.height = hoehe;
    return c;
  }

  /* In einem Rutsch von 4032 auf 1536 zu zeichnen laesst feine Strukturen
     (genau die Fellmuster, auf die es ankommt) flimmern - der Browser tastet
     dabei nur wenige Quellpixel ab. Ueber Zwischenschritte von jeweils halber
     Groesse bleibt das Bild sauber. */
  function verkleinern(quelle, breite, hoehe, zielBreite, zielHoehe) {
    var aktuell = quelle;
    var b = breite;
    var h = hoehe;
    var schritte = 0;
    while (b / 2 >= zielBreite && schritte < 4) {
      b = Math.round(b / 2);
      h = Math.round(h / 2);
      var zwischen = leinwand(b, h);
      var zk = zwischen.getContext('2d');
      zk.imageSmoothingEnabled = true;
      zk.imageSmoothingQuality = 'high';
      zk.drawImage(aktuell, 0, 0, b, h);
      if (aktuell !== quelle) aktuell.width = aktuell.height = 0;
      aktuell = zwischen;
      schritte++;
    }
    var ziel = leinwand(zielBreite, zielHoehe);
    var k = ziel.getContext('2d');
    k.imageSmoothingEnabled = true;
    k.imageSmoothingQuality = 'high';
    /* JPEG kennt keine Transparenz. Ohne diese Flaeche wird aus einem
       freigestellten PNG ein Foto mit schwarzem Grund. Weiss passt zu der
       Freistellung, die der Prompt ohnehin verlangt. */
    k.fillStyle = '#ffffff';
    k.fillRect(0, 0, zielBreite, zielHoehe);
    k.drawImage(aktuell, 0, 0, zielBreite, zielHoehe);
    if (aktuell !== quelle) aktuell.width = aktuell.height = 0;
    return ziel;
  }

  /* Auf iPhones und schwachen Android-Geraeten hat Canvas eine harte
     Speichergrenze. Wird sie ueberschritten, meldet der Browser keinen Fehler,
     sondern liefert eine leere Flaeche - wir haetten sie eben weiss gefuellt
     und wuerden ein reinweisses Bild hochladen. Der Kunde bekaeme ein leeres
     Poster, und niemand wuerde es vorher bemerken. Deshalb fuenf verteilte
     Stichproben: sind alle exakt gleich, ist beim Zeichnen etwas schiefgegangen
     und das Original ist die sichere Wahl. Ein echtes Foto besteht diese
     Pruefung immer - selbst vor weisser Wand rauscht der Sensor. */
  function hatInhalt(canvas) {
    try {
      var k = canvas.getContext('2d');
      var b = canvas.width;
      var h = canvas.height;
      var punkte = [
        [b >> 2, h >> 2],
        [(b * 3) >> 2, h >> 2],
        [b >> 1, h >> 1],
        [b >> 2, (h * 3) >> 2],
        [(b * 3) >> 2, (h * 3) >> 2]
      ];
      var erster = null;
      for (var i = 0; i < punkte.length; i++) {
        var d = k.getImageData(punkte[i][0], punkte[i][1], 1, 1).data;
        var wert = d[0] + ',' + d[1] + ',' + d[2];
        if (erster === null) erster = wert;
        else if (wert !== erster) return true;
      }
      return false;
    } catch (e) {
      /* Kein Zugriff auf die Pixel (etwa bei gesperrtem Canvas): nicht
         schlechter machen als vorher, also durchlassen. */
      return true;
    }
  }

  function alsBlob(canvas, guete) {
    return new Promise(function (aufloesen, ablehnen) {
      canvas.toBlob(
        function (blob) {
          if (blob) aufloesen(blob);
          else ablehnen(new Error('kein_blob'));
        },
        'image/jpeg',
        guete
      );
    });
  }

  function verarbeiten(datei) {
    var quelle = null;
    return bildLesen(datei)
      .then(function (bild) {
        quelle = bild;
        var breite = bild.width || bild.naturalWidth;
        var hoehe = bild.height || bild.naturalHeight;
        if (!breite || !hoehe) throw new Error('keine_masse');

        var faktor = Math.min(1, ZIEL_KANTE / Math.max(breite, hoehe));
        var zielBreite = Math.max(1, Math.round(breite * faktor));
        var zielHoehe = Math.max(1, Math.round(hoehe * faktor));

        /* Schon klein genug und trotzdem eine grosse Datei? Dann liegt es an
           der Qualitaetsstufe, nicht an den Massen - neu zu berechnen lohnt
           sich weiterhin. */
        var ziel = verkleinern(quelle, breite, hoehe, zielBreite, zielHoehe);
        if (!hatInhalt(ziel)) {
          ziel.width = ziel.height = 0;
          throw new Error('leeres_ergebnis');
        }
        return alsBlob(ziel, QUALITAET).then(function (blob) {
          if (blob.size <= ZIEL_BYTES) return { blob: blob, canvas: ziel, breite: zielBreite, hoehe: zielHoehe };
          return alsBlob(ziel, QUALITAET_NOTFALL).then(function (kleiner) {
            return { blob: kleiner, canvas: ziel, breite: zielBreite, hoehe: zielHoehe };
          });
        });
      })
      .then(function (ergebnis) {
        if (quelle && typeof quelle.close === 'function') quelle.close();
        ergebnis.canvas.width = ergebnis.canvas.height = 0;
        /* Groesser als vorher kann bei sehr stark komprimierten Vorlagen
           passieren. Dann ist das Original schlicht die bessere Datei. */
        if (ergebnis.blob.size >= datei.size) throw new Error('kein_gewinn');
        return new File([ergebnis.blob], nameSaeubern(datei.name), {
          type: 'image/jpeg',
          lastModified: Date.now()
        });
      })
      .catch(function (fehler) {
        if (quelle && typeof quelle.close === 'function') quelle.close();
        throw fehler;
      });
  }

  /* input.files ist nur ueber eine DataTransfer-Liste beschreibbar. Browser
     ohne DataTransfer (oder mit gesperrtem files-Setter) bekommen das Original. */
  function dateiSetzen(input, datei) {
    try {
      var dt = new DataTransfer();
      dt.items.add(datei);
      input.files = dt.files;
      return !!input.files && input.files.length === 1 && input.files[0].size === datei.size;
    } catch (e) {
      return false;
    }
  }

  function weiterreichen(input) {
    erledigt.add(input);
    laeuft.delete(input);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function abfangen(ev) {
    var input = ev.target;
    if (!input || input.type !== 'file') return;
    if (!input.closest || !input.closest('.tee-photo')) return;
    /* Unser eigener zweiter Durchlauf - ab hier nicht mehr eingreifen. */
    if (erledigt.has(input)) {
      erledigt.delete(input);
      return;
    }
    if (laeuft.has(input)) return;

    var datei = input.files && input.files[0];
    if (!datei || !/^image\//.test(datei.type || '')) return;
    if (datei.size < LOHNT_AB_BYTES) return;
    if (typeof DataTransfer !== 'function') return;

    ev.stopImmediatePropagation();
    ev.preventDefault();
    laeuft.add(input);

    var start = Date.now();
    var vorher = datei.size;
    var mime = datei.type || 'unbekannt';

    mitZeitgrenze(verarbeiten(datei), GRENZE_MS).then(
      function (klein) {
        var dauer = Date.now() - start;
        if (!dateiSetzen(input, klein)) {
          melden('configurator_photo_compress_skip', { reason: 'files_nicht_setzbar', photo_mime: mime });
          weiterreichen(input);
          return;
        }
        melden('configurator_photo_compress', {
          photo_mime: mime,
          photo_bytes_before: vorher,
          photo_bytes_after: klein.size,
          photo_saved_percent: Math.round((1 - klein.size / vorher) * 100),
          photo_compress_ms: dauer
        });
        weiterreichen(input);
      },
      function (fehler) {
        melden('configurator_photo_compress_skip', {
          reason: String((fehler && fehler.message) || 'unbekannt').slice(0, 40),
          photo_mime: mime,
          photo_bytes_before: vorher,
          photo_compress_ms: Date.now() - start
        });
        weiterreichen(input);
      }
    );
  }

  document.addEventListener('change', abfangen, true);
}());
